module.exports = __webpack_public_path__ + "img/quest_robot.b033c43c.svg";